export default "__VITE_ASSET__aQ1lHR0F__"